import { logger } from '../hlsjs/utils/logger';
import EME from './EME';

class ModernEME extends EME {
	constructor(hls, keySystem, obtainKeySystemConfigCallback, video, totalSessions) {
		logger.log(`ModernEME: constructor`);

		super(hls, keySystem, obtainKeySystemConfigCallback, totalSessions);

		this._options = null;
		this._ensurePromise = null;
		this._video = video;
		this._sessions = [];
		this.encrypted = this.onEncrypted.bind(this);
		this.message = this.obtainLicense.bind(this);
		this._video.addEventListener('encrypted', this.encrypted);
	}

	setOptions(options) {
		this._options = options;
	}

	dispose() {
		if(this._video) {
			this._video.removeEventListener('encrypted', this.encrypted);
			this._video = null;
		}

		while(this._sessions.length > 0) {
			let session = this._sessions.shift();
			session.removeEventListener('message', this.message);

			session.close()
			.then(() => {
				logger.log(`dispose: media key session closed`);
				session.remove()
				.then(() => {
					logger.log(`dispose: media key session removed`);
				})
				.catch(() => {
					logger.log(`dispose: failed to remove the media key session`);
				});
			})
			.catch(() => {
				logger.log(`dispose: failed to close the media key session`);
			});
		}

		this._options = null;
	}

	ensureMediaKeysCreated() {
		// We may already have a MediaKeys object if we initialized EME for a
		// different MSE SourceBuffer's "encrypted" event, or the initialization
		// may still be in progress.
		if (this._ensurePromise) {
			logger.log(`ensureMediaKeysCreated: media keys already created`);
			return this._ensurePromise;
		}

		this._ensurePromise = navigator.requestMediaKeySystemAccess(this._keySystem, this._options)
		.then((keySystemAccess) => {
			logger.log(`ensureMediaKeysCreated: createMediaKeys`);
			return keySystemAccess.createMediaKeys();
		})
		.then((mediaKeys) => {
			if(!this._video.mediaKeys) {
				logger.log(`ensureMediaKeysCreated: setMediaKeys`);
				return this._video.setMediaKeys(mediaKeys);
			}
			else {
				logger.log(`ensureMediaKeysCreated: media keys already set`);
				return this._video.mediaKeys;
			}
		})
		.catch((err) => {
			this.onError(err);
		});

		return this._ensurePromise;
	}

	onEncrypted(event) {
		if(this._sessions.length < this._totalSessions) {
			this.ensureMediaKeysCreated()
			.then(() => {
				logger.log(`onEncrypted: createSession`);
				let session = this._video.mediaKeys.createSession();
				//session.addEventListener("keystatuseschange", KeysChange);
				session.addEventListener('message', this.message);
				this._sessions.push(session);

				return session.generateRequest(event.initDataType, event.initData);
			})
			.then(() => {
				logger.log(`onEncrypted: generated request`);
			})
			.catch((err) => {
				this.onError(err);
			});
		}
	}
}

export default ModernEME;



// WEBPACK FOOTER //
// ./src/drm/ModernEME.js